import { createFileRoute } from '@tanstack/react-router'

import { BrandDashboardPage } from '@/features/brand/BrandDashboardPage'
import { validateBrandsSearch } from '@/features/brand/brands-search'

/** Authenticated, workspace-scoped daily brand switchboard. */
export const Route = createFileRoute('/_app/brands')({
  validateSearch: validateBrandsSearch,
  component: BrandDashboardPage,
})
